<template>
  <b-form ref="real_form" class="rails_form" v-bind="$attrs" v-on="$listeners">
    <input type="hidden" name="authenticity_token" :value="csrf_token" />
    <input name="utf8" type="hidden" value="&#x2713;" />
    <slot></slot>
  </b-form>
</template>

<script>
import api from "@/src/api.js";

export default {
  computed: {
    csrf_token: function() {
      return $('meta[name="csrf-token"]').attr("content");
    },
  },
  methods: {
    submit: function(url, extra_values = {}) {
      const formData = new FormData(this.$refs.real_form);
      for (const [k, v] of Object.entries(extra_values)) {
        formData.append(k, v);
      }

      return api({ method: "post", url: url, data: formData, headers: { "Content-Type": "multipart/form-data" } });
    }
  }
}
</script>